// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import "jquery/dist/jquery";
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

import AOS from "aos/dist/aos";
import "owl.carousel2/dist/owl.carousel";

// import "./components/sly";
// import "jquery.easing/jquery.easing";


// Initialise our components on jQuery.ready…
jQuery(function ($) {
	
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();

	fix_grid_height();

	setTimeout(function(){
		fix_grid_height();
	}, 2000);

	AOS.init();

	var relatedProductsSlider = $('#related-products');

	relatedProductsSlider.owlCarousel({
		loop:true,
		margin:18,
		responsiveClass:true,
		autoHeight: false,
		nav: false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4,
				loop:false
			}
		}
	})

	$('.slider-navigation.prev').click(function() {
		relatedProductsSlider.trigger('prev.owl.carousel');
	});

	$('.slider-navigation.next').click(function() {
		relatedProductsSlider.trigger('next.owl.carousel');
	});
	
	
	var homepageSlider = $('#homepage-carousel');

	homepageSlider.owlCarousel({
		loop:true,
		// margin:18,
		responsiveClass:true,
		autoHeight: false,
		nav: false,
		items:1
	})

	$('.slider-navigation.prev').click(function() {
		homepageSlider.trigger('prev.owl.carousel');
	});

	$('.slider-navigation.next').click(function() {
		homepageSlider.trigger('next.owl.carousel');
	});

	var initialHeader = $("#header-wrapper").outerHeight();

    $(".inline-block-has-children > a").click(function(e) {
		// e.stopImmediatePropagation();
		var $this = this;
		var screenWidth = $(document).width();

		$($this).closest('.inline-block-has-children').siblings().each(function(){
			$(this).removeClass('dropdown-active');

			$(this).each(function() {
				$(this).find('.sub-menu').slideUp();
			});
		});

		$($this).closest('.inline-block-has-children').toggleClass('dropdown-active');
		
		if(!$($this).closest('.sidebar-wrapper').hasClass('blog')) {
			if(screenWidth < 1024) {
				console.log('fires');
				$($this).closest('.inline-block-has-children').find('.sub-menu').slideToggle();
			}
		} else {
			$($this).closest('.inline-block-has-children').find('.sub-menu').slideToggle();
		}

		return false;
	});

	var anchorLink = $(window.location.hash);
    // test to see if the link is a anchor link, if not the length will have no value, this is done to avoid js errors on non anchor links
	if ( anchorLink.length ) {
		// setTimeout(function(){
			console.log('anchor link');
			// set an element as the fixed entity, header in this case and get its height
			// var offsetSize = jQuery("header").innerHeight();
			var offsetSize = $('.product-category-sticky').outerHeight();
			// fire the animation from the top of the page to the anchor link offsetting by the fixed elements height, the number is the speed of the animation
			jQuery("html, body").animate({scrollTop: anchorLink.offset().top - offsetSize }, 500);
		// }, 1000)
	}
	
	$("html").click(function(e) {
		if( !$(e.target).closest('li').hasClass('inline-block-has-children') && !$(e.target).closest('.navbar-wrapper').hasClass('dropdown-active') ) {
			$('.inline-block-has-children').removeClass('dropdown-active');
		}
    });
	
	$('.product-category-anchor').click(function(){
		var $this = this;
		// setTimeout(function(){
			console.log($($this).attr('href'));
			jQuery('html,body').animate({scrollTop: ($($($this).attr('href')).offset().top) - $('.product-category-sticky').outerHeight()}, 'slow');
		// }, 250);
	});
	
	$(".close-search, .search-btn").click(function(e) {
		e.preventDefault();
		
		$('.search-popup').fadeToggle();
	});

	$(".sidebar-toggle, .overlay").click(function(e) {
		e.preventDefault();
		console.log('sidebar-toggle');

		$(".sidebar-wrapper").removeClass('active'); // open sidebar
		
		setTimeout(() => {
			$(".navbar-wrapper").toggleClass('active');
			$("body").toggleClass('sidebar-toggled');
			$("html").toggleClass('overflow-hidden');
		}, 100);
    });
    
	$(window).resize(function () {
		fix_grid_height();

		var checkWidth = $(window).width();

		$(".inline-block-has-children").each(function(i, elem){
			$(elem).removeClass('dropdown-active');
			$(elem).find('.sub-menu').hide(200, function() {
				$(this).attr('style', '');
			});
		});

		if(checkWidth < 1024) {
			if(!$(".navbar-wrapper").hasClass('active')) {
				$(".sidebar-wrapper").addClass('active').css('height', jQuery(window).outerHeight()); // close sidebar / ready the sidebar to be trigger
			}
		} else {
			$("html").removeClass('overflow-hidden');
			$(".sidebar-wrapper").removeClass('active').css('height', ''); // open sidebar
			$(".navbar-wrapper").removeClass('active');
		}
	});
	
	$(window).scroll(function () {
		var screenWidth = $(document).width();
		
		if ($(this).scrollTop() >= 100) {
			$("#header-wrapper").addClass('sticky-active');

		// 	if(screenWidth >= 1024) {
		// 		initialHeader = $(".navbar-wrapper").outerHeight();
		// 	}
			
		// 	$("#content-wrapper").css('padding-top', (initialHeader));

		} else {
			$("#header-wrapper").removeClass('sticky-active');
		// 	$("#content-wrapper").css('padding-top', 0);
		// 	initialHeader = $("#header-wrapper").outerHeight();
		}
	});

	/**
	 * Fix grid height
	 */
	function fix_grid_height() {
		if(jQuery('.fix-height').length > 0) {
			// Resize the size
			jQuery('.fix-height').height('auto');

			// Only higher than Tablet Viewport
			if(jQuery(window).width() >= 768) {
				if(jQuery('.fix-height:not([data-fix-height-group])').length > 0) {
					var d = new Date();
					var n = d.getTime();
					jQuery('.fix-height:not([data-fix-height-group])').each(function() {
						jQuery(this).attr('data-fix-height-group', n);
					});
				}

				var untrimmed_groups = jQuery('.fix-height').map(function() {
					return jQuery(this).attr('data-fix-height-group');
				}).get();

				var trimmed_groups = untrimmed_groups.filter( only_unique_values );

				for (var i = trimmed_groups.length - 1; i >= 0; i--) {

					var selector = jQuery('.fix-height[data-fix-height-group="'+trimmed_groups[i]+'"]');

					var elementHeights = selector.map(function() {
						return jQuery(this).height();
					}).get();

					// Math.max takes a variable number of arguments
					// `apply` is equivalent to passing each height as an argument
					var maxHeight = Math.max.apply(null, elementHeights);

					// Set each height to the max height
					selector.height(maxHeight);
				}
			}
		}
	}

	function only_unique_values(value, index, self) { 
		return self.indexOf(value) === index;
	}

});